import { PropsWithChildren } from 'react'

import { DownloaderRepository } from '@/Shared/domain'
import { createGenericContext } from '@/Shared/ui/createGenericContext'

type Context = {
  repository: DownloaderRepository
}

type Props = PropsWithChildren & {
  repository: DownloaderRepository
}

const [useDownloader, StateContextProvider] = createGenericContext<Context>()

const DownloaderProvider = ({ repository, children }: Props): JSX.Element => (
  <StateContextProvider value={{ repository }}>{children}</StateContextProvider>
)

export { DownloaderProvider, useDownloader }
